import { render, staticRenderFns } from "./historyPoints.vue?vue&type=template&id=4fd2c5ba&scoped=true&"
import script from "./historyPoints.vue?vue&type=script&lang=js&"
export * from "./historyPoints.vue?vue&type=script&lang=js&"
import style0 from "./historyPoints.vue?vue&type=style&index=0&id=4fd2c5ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2c5ba",
  null
  
)

export default component.exports